import React from 'react';

import {
  SearchableListItem,
  SearchableListItemBody,
} from '../SearchableListItem/SearchableListItem';

import type {OptionType} from '../_types';

export const renderDefaultOption = (option: OptionType) => {
  const {description, label, isDisabled, isMultiline, prefix, value} = option;

  return (
    <SearchableListItem isDisabled={isDisabled} key={value} prefix={prefix}>
      <SearchableListItemBody
        description={description}
        isMultiline={isMultiline}
      >
        {label}
      </SearchableListItemBody>
    </SearchableListItem>
  );
};
